exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.forthing-table[data-v-3e322101] {\n    border-collapse: separate;\n    border: 1px solid rgba(0, 0, 0, 0.125);\n    border-radius: 0.25rem;\n    overflow: hidden;\n}\n.center-items[data-v-3e322101] {\n    width: 100%;\n    margin: 0 auto;\n}\n.forthing-history-button-label[data-v-3e322101] {\n    white-space: nowrap;\n}\n.aube_user_wallet_check_color[data-v-3e322101] {\n    color: #450080;\n}\n.aube_stake_check_color[data-v-3e322101] {\n    color: #00ad69;\n}\n", ""]);

// exports
